const GRID_TOP_PX = 40;
const GRID_PLOT_HEIGHT_PX = 180;
const PASS_1_GRID_HEIGHT_PLACEHOLDER_PX = 400;
const PASS_1_SCRATCH_HEIGHT_PX = GRID_TOP_PX + PASS_1_GRID_HEIGHT_PLACEHOLDER_PX + 40;

// GRID_PLOT_HEIGHT_PX is the plot's fixed height; the rest reserve room containLabel won't (see chart-measurement.utility).
// PASS_1_GRID_HEIGHT_PLACEHOLDER_PX is a generous placeholder so containLabel doesn't squeeze the plot to fit rotated labels, which would corrupt the pass-2 measurement.
export const ChartLayout = {
  GRID_TOP_PX,
  GRID_PLOT_HEIGHT_PX,
  PASS_1_GRID_HEIGHT_PLACEHOLDER_PX,
  PASS_1_SCRATCH_HEIGHT_PX,
  X_AXIS_LABEL_ROTATE_DEGREES: 45,
  X_AXIS_NAME_GAP_BREATHING_PX: 8,
  X_AXIS_NAME_HEIGHT_PX: 16,
  Y_AXIS_NAME_LINE_HEIGHT_PX: 16,
  Y_AXIS_NAME_GAP_BREATHING_PX: 8,
  Y_AXIS_NAME_LEFT_BREATHING_PX: 16,
  Y_AXIS_NAME_ROTATE_DEGREES: 90,
  LEGEND_TOP_GAP_PX: 12,
  LEGEND_BOTTOM_PADDING_PX: 8,
} as const;
